<section class="main">
    <div class="header-wrapper">
        <div class="table-title">
            <div class="head-button">
                <button class="r-btn" (click)="backToMainTable()"><i class="icon bi bi-arrow-left"></i></button>
                <span class="head-text"></span>
            </div>
            <div class="title-text">
                {{ pureOriginalResultsService.tableTitle() }}
            </div>
        </div>

        <div class="filter-wrapper">
            <div class="filtering-buttons">
                <button class="custom-btn" (click)="openAdvancedSearchSettings()"><span>Filters</span><i
                        class="bi bi-funnel"></i>
                    @if (filterCount() > 0) {
                        <p class="count-filter">{{ filterCount() }}</p>
                    }</button>
            </div>
        </div>

        @if (pureOriginalResultsService.openAdvanceSettings()) {
            <app-most-requested-tuning-filters
                    [displayedColumns]="pureOriginalResultsService.displayedColumns()"
                    [persistFilters]="!pureOriginalResultsService.routeDriven()"
                    (mostRequestedFilterClosed)="onAdvancedSettingClosed($event)"
                    (selectedFiltersChange)="selectFilters($event)"
                    (filterCount)="updateFilterCount($event)"
            ></app-most-requested-tuning-filters>
        }
    </div>

    @if (activeEcuFilter(); as ecu) {
        <div class="ecu-filter-summary">
            <span class="ecu-filter-chip">ECU Build: <strong>{{ ecu.value || '(Empty value)' }}</strong><button type="button" (click)="removeEcuFilter()" [attr.aria-label]="'Remove ECU Build filter ' + ecu.value"><i class="bi bi-x-lg" aria-hidden="true"></i></button></span>
            @if (pureOriginalResultsService.tuningTotal() != null) {<span>{{ pureOriginalResultsService.tuningTotal() | number }} tuning records</span>}
        </div>
    }
    @if (pureOriginalResultsService.tuningLoadError()) {
        <div class="tuning-load-state" role="alert">{{ pureOriginalResultsService.tuningLoadError() }}<button type="button" (click)="pureOriginalResultsService.retryTunings()">Retry</button></div>
    }
    @if (pureOriginalResultsService.isLoading()) {<div class="tuning-load-state" role="status">Loading tunings…</div>}
    @defer (when !pureOriginalResultsService.isLoading()) {
        @if (!isTableEmpty()) {
            <div class="table-container" infinite-scroll
                 [scrollWindow]="false"
                 [infiniteScrollDistance]="2"
                 [infiniteScrollDisabled]="pureOriginalResultsService.isLoading() || !pureOriginalResultsService.hasMoreTunings() || !!pureOriginalResultsService.tuningLoadError()"
                 (scrolled)="onScroll()">
                <table mat-table [dataSource]="pureOriginalResultsService.mostRequestedTunings()"
                       matSort
                       matSortDisableClear
                       [matSortActive]="pureOriginalResultsService.sortDirectionValues().active"
                       [matSortDirection]="pureOriginalResultsService.sortDirectionValues().direction"
                       (matSortChange)="changeSortDirection($event)"
                       [ngClass]="pureOriginalResultsService.displayedTableHeaders().includes('actions') ? 'sticky-header': ''">

                    @for (column of pureOriginalResultsService.displayedColumns(); track $index) {
                        <ng-container [matColumnDef]="column">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column }}</th>
                            <td mat-cell *matCellDef="let element">{{ formatDate(element[column], column) | shorten: 25 }}</td>
                        </ng-container>
                    }

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let element" class="actions-details"
                            (click)="$event.stopPropagation()">

                            <div class="checkbox-wrapper-18">
                                <div class="round">
                                    <input type="checkbox" id="checkbox-18"
                                           [checked]="element.enabled"
                                           (change)="changeMissingTuning($event, element.id, element.tuningName)"/>
                                    <label for="checkbox-18"
                                           [matTooltip]="'Change tuning to be impossible'"></label>
                                </div>
                            </div>

                            <button class="table-buttons"
                                    (click)="deleteMissingTuning(element.id, 'PURE_ORIGINAL_MISSING_VERSIONS')"><i
                                    class="bi bi-trash"></i></button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="pureOriginalResultsService.displayedTableHeaders()"></tr>
                    <tr mat-row *matRowDef="let element; columns: pureOriginalResultsService.displayedTableHeaders()"
                        (click)="onRowClick($event, element)"></tr>
                </table>
            </div>
        } @else {
            @if (!pureOriginalResultsService.isLoading() && !pureOriginalResultsService.tuningLoadError()) {
                <div class="empty-table-wrapper">
                    <div class="empty-table">NO RESULTS</div>
                </div>
            }
        }
    } @placeholder (minimum 150ms) {
        <div>
            <app-skeleton-table></app-skeleton-table>
        </div>
    }
</section>
